import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  isNavigatingToCreationPageSelector,
  registerCompanySelector
} from '../../helpers/selectors';
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import { getMessage as t, isValidId, navigateToHomePage } from '../../utils/utils';
import { addErrorMsg } from '../../utils/flashMessage/creator';
import {
  autoUpdateRegisterIncompleteStatus,
  getRegisterCompany,
  setSubscribeLoaderState
} from '../../actions/user';
import { creation as cr } from '../../constants/routes';
import { getCreationId } from '../../helpers/components';

function getMaxSteps() {
  return 4;
}

function renderStepLine(index) {
  if (index < getMaxSteps() - 1) {
    return <div key={index + '.sub'} className="scope-step-line" />;
  }
}

function getActiveIndex(s, i) {
  return i === s.pageIndex;
}

function renderStepNumber(s, i) {
  return (
    <div
      key={i}
      className={classnames('scope-step', {
        'sub-class-active': getActiveIndex(s, i)
      })}
    >
      {i + 1}
    </div>
  );
}

function renderSteps(s) {
  const steps = [];

  for (let i = 0; i < getMaxSteps(); i++) {
    steps.push(renderStepNumber(s, i));
    steps.push(renderStepLine(i));
  }
  return steps;
}

function renderCompanyName(p) {
  return p?.company?.name || <FormattedMessage id="generic.company" />;
}

function startFetch(p, r) {
  r.loadingCount += 1;
  p.setSubscribeLoaderState(true);
}

function finishFetch(p, r) {
  r.loadingCount -= 1;
  if (r.loadingCount === 0) {
    p.setSubscribeLoaderState(false);
  }
}

function getCompanyDataOnLoad(p, r) {
  const id = getCreationId(p);
  startFetch(p, r);

  if (isValidId(id)) {
    p.getRegisterCompany(id).then(() => finishFetch(p, r));
  } else {
    finishFetch(p, r);
    navigateToHomePage();
    addErrorMsg(t(p.m, 'error.invite.code.invalid'));
  }
}

const pageIndexMap = [
  `${cr.container}/${cr.credentials}/*`,
  `${cr.container}/${cr.activate}/*`,
  `${cr.container}/${cr.info}/*`
];

function Creation(p) {
  const { pathname } = useLocation();
  const [s, setS] = useState({ pageIndex: 0 });

  const r = useRef({
    loadingCount: 0,
    p: null
  }).current;

  useEffect(() => {
    setS({
      pageIndex: pageIndexMap.findIndex((route) => matchPath(route, pathname))
    });
  }, [pathname]);

  // save latest props to ref for unmount
  useEffect(() => {
    r.p = p;
  }, [p]);

  useEffect(() => {
    getCompanyDataOnLoad(p, r);
    return () => {
      const p = r.p; // restore latest props
      if (!p.isNavigatingToCreationPage) {
        p.autoUpdateRegisterIncompleteStatus();
      }
    };
  }, []);

  return (
    <div className={classnames('creation-page', 'register-page', 'profile-page')}>
      <div className={classnames('scope-page-header')}>
        <div className="scope-title-container">
          <FormattedMessage id="part.create.account.for" />
          <div className="scope-company-name">{renderCompanyName(p)}</div>
        </div>
        <div className="scope-steps-container">{renderSteps(s)}</div>
      </div>
      <div className={classnames('scope-content', 'active')}>
        <Outlet />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    company: registerCompanySelector(state),
    isNavigatingToCreationPage: isNavigatingToCreationPageSelector(state)
  };
}

const mapDispatchToProps = {
  setSubscribeLoaderState,
  getRegisterCompany,
  autoUpdateRegisterIncompleteStatus
};

Creation = connect(mapStateToProps, mapDispatchToProps)(Creation);

export default Creation;
